var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Typography = void 0;
var Typography_1 = __importDefault(require("./Typography"));
exports.Typography = Typography_1.default;
exports.default = Typography_1.default;
//# sourceMappingURL=index.js.map